/** Count badge in the corner of a header icon: 600 12/16 on the brand color. */
export const HEADER_BADGE_CLASS =
  'absolute -top-1.5 -right-2 flex h-4 min-w-4 items-center justify-center rounded-[8px] bg-[#E94E1A] px-1 text-center font-semibold text-[12px] text-white leading-4';

/** Header icon button: 22px glyph, brand color on hover. */
export const HEADER_ICON_CLASS =
  'relative flex cursor-pointer text-[#141415]! transition-colors duration-[120ms] hover:text-[#E94E1A]!';
